Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-code-validation-form');
    var registrationFormWrapper = $('.loyalty-registration-container');

    if ($form.length < 1)
        return;

    var form = $form.get(0);

    form.InitValidationForm = function (registrationWrapper) {

        var $errorWrapper, $errorMessage, $submitButton,
            formData, valOpts,
            validationCodeFormPartial = "loyaltyValidationCodeForm_A";
        var $registrationWrapper = registrationWrapper.get(0);

        var form = $form.get(0);


        form.loading = function (loading) {
            if (loading) {
                $form.addClass('x-loading');
            } else {
                $form.removeClass('x-loading');
            }
        };


        form.onValidateSmsSuccess = function (envelope) {

            var data = envelope.message.data;

            if (data.StatusCode === 200) {
                form.hide();

                if ($registrationWrapper) {
                    $registrationWrapper.InitLoyaltyRegistrationForm();
                }

            } else {
                $errorMessage.text(data.ResponseMessage);
                $errorMessage.show();
                form.loading(false);
            }
        }

        form.initForm = function (model) {
            form.loading(true);

            var html = Vendd.Handlebars.parse(validationCodeFormPartial, model);

            $form.html(html);
            if (model.SuccessfullySend) {
                notyf.success(model.SuccessfullySendText);

                form.bind(model.ValidationForm.Mobile);
            }

            form.loading(false);
        }

        form.bind = function (mobile) {

            $errorWrapper = $('.code-error-wrapper', form);
            $errorMessage = $('.code-error-message', $errorWrapper);

            formData = {
                "code": $('input[name="code"]').val(),
                "mobile": mobile
            };

            valOpts = {
                code: {
                    required: 'code-required'
                }
            };

            $form.validationEngine(valOpts);
            var rf = $form.data('validationEngine');

            $submitButton = $('.js-validate-code-submit-button', $form);

            $form.on('click', '.js-validate-code-submit-button', function (e) {

                valOpts = $form.validationEngine();

                $form.validationEngine(valOpts);
                var rf = $form.data('validationEngine');

                var valid = rf.validate();

                if (valid) {
                    form.submitForm();
                }
            });

            $form.on('keyup', 'input[name]', function (e) {
                $errorMessage.hide();

                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    $submitButton.click();

                    return;
                };

                var $this = $(this);
                var fieldName = $this.attr('name');

                formData[fieldName] = $this.val();
                rf = $form.data('validationEngine');
                rf.validate(fieldName);
            });
        }

        form.submitForm = function () {
            form.loading(true);

            formData.mobile = omitScriptTag($('input[name="mobile"]').val());
            formData.code = omitScriptTag($('input[name="code"]').val());

            Vendd.MessageBus.publishAsync(form, new Vendd.Loyalty.Messages.ValidateSmsCode(formData.mobile, formData.code));
        }

        form.hide = function () {
            $form.hide();
        };

        form.getMobile = function () {
            return sessionStorage.getItem('LoyaltyMobilePhone');
        };

        form.removeMobile = function () {
            sessionStorage.removeItem('LoyaltyMobilePhone');
        };

        form.init = function () {
            var mobile = form.getMobile();
            if (mobile) {
                Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SendSms(mobile));
            } else {
                // show phone form without redirecting on success....
            }
        };


        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SendSmsSuccess, form, function (envelope) {
            var model = envelope.message.data;
            form.initForm(model);
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SendSmsFailure, form, function () {
            form.loading(false);
            notyf.error('Something went wrong');
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ValidateSmsCodeSuccess, form, form.onValidateSmsSuccess);

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ValidateSmsCodeFailure, form, function () {
            form.loading(false);
            notyf.error('Something went wrong');
        });

        form.init();
    }

    if ($form.data('initform')) {
        form.InitValidationForm(registrationFormWrapper);
    }

});